const PKCE_VERIFIER_PATTERN = /^[A-Za-z0-9._~-]{43,128}$/u;

function base64UrlEncode(bytes: Uint8Array): string {
  let binary = '';
  for (const byte of bytes) {
    binary += String.fromCharCode(byte);
  }
  return btoa(binary).replaceAll('+', '-').replaceAll('/', '_').replace(/=+$/u, '');
}

export function generatePkceVerifier(cryptoApi: Crypto = globalThis.crypto): string {
  const bytes = new Uint8Array(48);
  cryptoApi.getRandomValues(bytes);
  const verifier = base64UrlEncode(bytes);

  if (!PKCE_VERIFIER_PATTERN.test(verifier)) {
    throw new Error('Generated PKCE verifier does not satisfy RFC 7636 constraints.');
  }
  return verifier;
}

export async function createPkceS256Challenge(
  verifier: string,
  cryptoApi: Crypto = globalThis.crypto,
): Promise<string> {
  if (!PKCE_VERIFIER_PATTERN.test(verifier)) {
    throw new Error('PKCE verifier must contain 43-128 RFC 7636 unreserved characters.');
  }

  const digest = await cryptoApi.subtle.digest('SHA-256', new TextEncoder().encode(verifier));
  return base64UrlEncode(new Uint8Array(digest));
}
